import { combineReducers } from 'redux';
import byId from './byId';
import allIds from './allIds';
import count from './count';

export default combineReducers({ byId, allIds, count });
